<template>
    <grid
        ref="issuedPolicies"
        :is-auto-height="true"
        :is-auto-width="true"
        :is-search="false"
        :get-row-id="getRowId"
        :row-data="value"
        :column-defs="columnDefs"
        :style="{ marginBottom: '1rem' }"
        :getRowStyle="getRowStyle"
        grid-theme="ag-theme-alpine-compact"
        :enableCellTextSelection="false"
    ></grid>
</template>

<script>
    import API from '../../../../api';
    import Grid from '../../../generic/grid/grid.vue';

    export default {
        name: 'IssuedPoliciesTable',
        components: {
            Grid,
        },
        props: {
            value: Array,
            totals: Array,
            metaReservationId: Number,
        },
        data() {
            return {
                isEdit: false,
                columnDefs: [
                    {
                        headerName: '',
                        maxWidth: 50,
                        resizable: false,
                        sortable: false,
                        cellStyle: { 'align-items': 'flex-end' },
                    },

                    {
                        headerName: 'Policy ID',
                        sortable: false,
                        field: 'external_policy_id',
                        flex: 3,
                    },
                    {
                        headerName: 'Product Name',
                        sortable: false,
                        field: 'description',
                        flex: 9,
                        autoWidthExclude: true,
                        minWidth: 200,
                    },
                ],
            };
        },
        methods: {
            getRowId(item) {
                return item.data.pos?.toString();
            },
            getRowStyle(params) {
                if (params.node.rowPinned === 'bottom') {
                    return {
                        'font-weight': 'bold',
                        'background-color': '#F8F8F8',
                    };
                }
            },
        },
    };
</script>
